<template>
  <b-dropdown variant="link" right @shown="onShown" toggle-class="py-0" v-if="recipient">
    <template v-slot:button-content>
      <i v-if="!busy" class="fa fa-fw fa-user"></i>
      <i v-if="busy" class="fa fa-fw fa-circle-notch fa-spin"></i>
    </template>
    <b-dropdown-header>
      <i class="fa fa-fw fa-user"></i>
      {{ recipient.name }}
    </b-dropdown-header>
    <b-dropdown-item :href="`${iframeUrlPrefix}/org/${this.organization.id}${isStaff ? '' : '/staff'}`" :disabled="busy" class="d-none">
      <i class="fa fa-fw fa-exchange-alt"></i>
      {{ trans(isStaff ? 'switch_to_client_portal' : 'switch_to_staff_portal') }}
    </b-dropdown-item>
    <b-dropdown-divider class="d-none"></b-dropdown-divider>
    <b-dropdown-item :href="`${iframeUrlPrefix}/org/${this.organization.id}/client`" :disabled="busy">
      {{ trans('my_account') }}
    </b-dropdown-item>
    <b-dropdown-item v-if="lang == 'en'" href="/lang/fr" :disabled="busy">
      Français
    </b-dropdown-item>
    <b-dropdown-item v-if="lang == 'fr'" href="/lang/en" :disabled="busy">
      English
    </b-dropdown-item>
    <b-dropdown-item v-if="!!recipient" @click="onClickDisconnect" :disabled="busy">
      {{ trans('disconnect') }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
  export default {
    props: {
      organization: Object,
      isStaff: false,
    },
    data() {
      return {
        trans: trans,
        lang: lang,
        busy: false,
        iframeUrlPrefix: _.iframeUrlPrefix,
        error: null,
        recipient: null,
      }
    },
    methods: {
      onShown() {
        if (this.busy && !this.error) return
        this.error = null
        this.fetch()
      },
      onClickDisconnect() {
        this.busy = true
        this.error = false
        let url = `${_.iframeUrlPrefix}/org/${this.organization.id}/client/disconnect`
        axios.get(url)
        .then(response => {
          window.location.reload()
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
        })
      },
      fetch() {
        this.busy = true
        this.error = false
        let url = `${_.iframeUrlPrefix}/org/${this.organization.id}/client/recipient`
        axios.get(url)
        .then(response => {
          this.busy = false
          this.recipient = _.isEmpty(response.data) ? null : response.data
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
        })
      },
    },
    mounted() {
      window.clientTopNavMenu = this
    },
  }
</script>
